export enum DaysOfWeek {
	sunday = 'sunday',
	monday = 'monday',
	tuesday = 'tuesday',
	wednesday = 'wednesday',
	thursday = 'thursday',
	friday = 'friday',
	saturday = 'saturday',
	weekDays = 'weekDays',
	weekEnds = 'weekEnds',
	allDays = 'allDays',
}
